// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sup-section {
  margin-bottom: 18px;
}

.sup-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.sup-section-title {
  margin-bottom: 0;
}

.sup-count-pill {
  font-size: 0.78rem;
  color: var(--text-primary, #0f172a);
  background: var(--bg-toolbar, #e2e8f0);
  border: 1px solid var(--border, #cbd5e1);
  border-radius: 999px;
  padding: 2px 10px;
  min-width: 1.75rem;
  text-align: center;
  line-height: 1.15;
  font-weight: 600;
}

.sup-empty-text {
  color: var(--text-muted, #94a3b8);
  font-size: 0.9rem;
}

.sup-info-card {
  background: var(--bg-card, #f8fafc);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  padding: 14px;
}

.sup-info-label {
  color: var(--text-muted, #64748b);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
}

.sup-info-value {
  color: var(--text-primary, #0f172a);
  font-size: 0.95rem;
  font-weight: 600;
}

.sup-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.sup-header-icon-wrap {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--accent, #2563eb) 12%, var(--bg-card, #f8fafc));
  color: var(--accent, #2563eb);
  flex-shrink: 0;
}

.sup-header-icon {
  width: 24px;
  height: 24px;
}

.sup-record-title {
  font-size: 1.35rem;
  margin-bottom: 2px;
}

.sup-record-subtitle {
  color: var(--text-muted, #64748b);
  font-size: 0.9rem;
}

.sup-message-muted {
  color: var(--text-muted, #64748b);
}

.sup-message-error {
  color: var(--danger, #b91c1c);
}

.sup-grid-list {
  display: grid;
  gap: 10px;
}

.sup-item-card {
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  padding: 14px;
  background: var(--bg-card, #fff);
}

.sup-item-card-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.sup-item-meta {
  color: var(--text-muted, #64748b);
  font-size: 0.85rem;
}

.sup-item-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  font-size: 0.88rem;
  color: var(--text-secondary, #334155);
}

.sup-table-wrap {
  overflow-x: auto;
}

.sup-table {
  margin-bottom: 0;
}

.sup-item-detail {
  font-size: 0.88rem;
  color: var(--text-secondary, #334155);
}

.sup-item-raw {
  margin-top: 6px;
  color: var(--text-muted, #64748b);
}

.sup-warning-list {
  display: grid;
  gap: 8px;
}

.sup-warning-card {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  border: 1px solid color-mix(in srgb, #f59e0b 55%, var(--border, #e2e8f0));
  background: color-mix(in srgb, #f59e0b 12%, var(--bg-card, #fff));
  color: color-mix(in srgb, #92400e 88%, var(--text-primary, #0f172a));
  border-radius: 10px;
  padding: 12px;
}

.sup-warning-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}

.sup-summary-list {
  display: grid;
  gap: 12px;
}

.sup-summary-card {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 12px;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  background: var(--bg-card, #fff);
}

.sup-summary-icon {
  width: 20px;
  height: 20px;
}

.sup-summary-icon-team {
  color: var(--accent, #2563eb);
}

.sup-summary-icon-users {
  color: #7c3aed;
}

.sup-summary-icon-clock {
  color: #0f766e;
}

.sup-summary-label {
  font-size: 0.8rem;
  color: var(--text-muted, #64748b);
}

.sup-summary-value {
  font-weight: 600;
  color: var(--text-primary, #0f172a);
}
`, "",{"version":3,"sources":["webpack://./src/styles/SystemUsersPanel.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mFAAmF;EACnF,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,yEAAyE;EACzE,iEAAiE;EACjE,oEAAoE;EACpE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC","sourcesContent":[".sup-section {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.sup-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.sup-section-title {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.sup-count-pill {\r\n  font-size: 0.78rem;\r\n  color: var(--text-primary, #0f172a);\r\n  background: var(--bg-toolbar, #e2e8f0);\r\n  border: 1px solid var(--border, #cbd5e1);\r\n  border-radius: 999px;\r\n  padding: 2px 10px;\r\n  min-width: 1.75rem;\r\n  text-align: center;\r\n  line-height: 1.15;\r\n  font-weight: 600;\r\n}\r\n\r\n.sup-empty-text {\r\n  color: var(--text-muted, #94a3b8);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.sup-info-card {\r\n  background: var(--bg-card, #f8fafc);\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n}\r\n\r\n.sup-info-label {\r\n  color: var(--text-muted, #64748b);\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sup-info-value {\r\n  color: var(--text-primary, #0f172a);\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.sup-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.sup-header-icon-wrap {\r\n  width: 46px;\r\n  height: 46px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: color-mix(in srgb, var(--accent, #2563eb) 12%, var(--bg-card, #f8fafc));\r\n  color: var(--accent, #2563eb);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sup-header-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.sup-record-title {\r\n  font-size: 1.35rem;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.sup-record-subtitle {\r\n  color: var(--text-muted, #64748b);\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.sup-message-muted {\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n.sup-message-error {\r\n  color: var(--danger, #b91c1c);\r\n}\r\n\r\n.sup-grid-list {\r\n  display: grid;\r\n  gap: 10px;\r\n}\r\n\r\n.sup-item-card {\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  background: var(--bg-card, #fff);\r\n}\r\n\r\n.sup-item-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sup-item-meta {\r\n  color: var(--text-muted, #64748b);\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sup-item-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 10px;\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary, #334155);\r\n}\r\n\r\n.sup-table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.sup-table {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.sup-item-detail {\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary, #334155);\r\n}\r\n\r\n.sup-item-raw {\r\n  margin-top: 6px;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n.sup-warning-list {\r\n  display: grid;\r\n  gap: 8px;\r\n}\r\n\r\n.sup-warning-card {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: flex-start;\r\n  border: 1px solid color-mix(in srgb, #f59e0b 55%, var(--border, #e2e8f0));\r\n  background: color-mix(in srgb, #f59e0b 12%, var(--bg-card, #fff));\r\n  color: color-mix(in srgb, #92400e 88%, var(--text-primary, #0f172a));\r\n  border-radius: 10px;\r\n  padding: 12px;\r\n}\r\n\r\n.sup-warning-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex-shrink: 0;\r\n  margin-top: 1px;\r\n}\r\n\r\n.sup-summary-list {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.sup-summary-card {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 12px;\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 10px;\r\n  background: var(--bg-card, #fff);\r\n}\r\n\r\n.sup-summary-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.sup-summary-icon-team {\r\n  color: var(--accent, #2563eb);\r\n}\r\n\r\n.sup-summary-icon-users {\r\n  color: #7c3aed;\r\n}\r\n\r\n.sup-summary-icon-clock {\r\n  color: #0f766e;\r\n}\r\n\r\n.sup-summary-label {\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n.sup-summary-value {\r\n  font-weight: 600;\r\n  color: var(--text-primary, #0f172a);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
